/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateLocationCommand } from '../../models/update-location-command';
import { UpdateLocationCommandResult } from '../../models/update-location-command-result';

export interface ApiLocationUpdateLocationPatch$Plain$Params {
      body?: UpdateLocationCommand
}

export function apiLocationUpdateLocationPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiLocationUpdateLocationPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateLocationCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationUpdateLocationPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateLocationCommandResult>;
    })
  );
}

apiLocationUpdateLocationPatch$Plain.PATH = '/api/Location/UpdateLocation';
